
import { defineComponent, nextTick } from 'vue';
import PrzLoader from '@/components/Muffin/Loader.vue';

export default defineComponent({
    name: 'ShopItem',
    components:{
        PrzLoader
    },
    props:{
        image:{
            type: String,
            default: null
        },
        name:{
            type: String,
            default: null
        },
        url:{
            type: String,
            default: null
        },
        variant:{
            type: String,
            default: null
        },
        price:{
            type: String,
            default: null
        },
        priceCrossed:{
            type: String,
            default: null
        },
        quantity:{
            type: String,
            default: null
        },
        hasStock:{
            type: Boolean,
            default: true
        },
        kStrings:{
            type: Object,
            default: () => {
                return { kGLOB_ADD_TO_CART: 'Add to cart', kPROD_STOCK_OUT: 'Out of stock'};
            }
        }
    },
    data(){
        return {
            showLoader: false
        };
    },
    computed: {
        isSameProduct():boolean{
            try{
                let productUrl = this.url;
                if(!productUrl){
                    return false;
                }
                let url = productUrl.includes('https://') || productUrl.includes('http://') ? new URL(productUrl) : new URL(productUrl, window.location.origin);
                return window.location.pathname == url.pathname;
            }catch(e){
                return false;
            }
        }
    },
    methods:{
        async gotoUrl() {
            if(!this.isSameProduct){
                this.$emit('goto-url');
                this.showLoader = true;
                await nextTick();
                window.location.assign(this.url);
            }
        }
    }
});
